export const GET_FINANCE_DATA = "GET_FINANCE_DATA";
export const GET_STATEMENT_DATA = "GET_STATEMENT_DATA";
export const GET_TRANSACTION_DATA = "GET_TRANSACTION_DATA";
export const SET_LOAN_STATEMENT_DATA = "SET_LOAN_STATEMENT_DATA";
export const CLEAR_FINANCE_STATE = "CLEAR_FINANCE_STATE";
